import { render, staticRenderFns } from "./CpPriceAction.vue?vue&type=template&id=6e310ca9&"
import script from "./CpPriceAction.vue?vue&type=script&lang=js&"
export * from "./CpPriceAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports